import { Injectable } from '@angular/core';
import { fromJS } from 'immutable';
import { extend, isArray, map, reduce } from 'lodash';
import { TrackingEvent } from './models/tracking-event.model';
import {
  ITrackingAction,
  ITrackingObject,
  ITrackingTraits,
} from './tracking.data';
import { environment } from '../../../environments/environment';

@Injectable()
export class TrackingBuilder {
  constructor() {}

  buildContext(traits: ITrackingTraits) {
    return {
      context: {
        app: {
          version: environment.version,
          name: 'web_app',
        },
        traits: this.buildTraits(traits),
      },
    };
  }

  buildTraits({
    accountId,
    userId,
    email,
    country,
    currencyCode,
    cardPaymentsStatus,
    purchaseWindow,
    expirationDate,
    planUuid,
  }: ITrackingTraits) {
    return extend({
      account_id: accountId || null,
      i2g_user_id: userId || null,
      email: email || null,
      company_country: country || null,
      company_currency: currencyCode || null,
      card_payments_status: cardPaymentsStatus || null,
      purchase_window: purchaseWindow || null,
      expiration_date: expirationDate || null,
      plan_uuid: planUuid || null,
    });
  }

  buildTrackingEvent(
    trackingObjects: ITrackingObject | ITrackingObject[],
    trackingAction: ITrackingAction,
    additionalProperties?: any
  ): TrackingEvent {
    const trackingObjectsName = isArray(trackingObjects)
      ? map(trackingObjects, (trackingObject) => trackingObject.name).join('_')
      : trackingObjects.name;
    const trackingObjectsProperties = isArray(trackingObjects)
      ? reduce(
          trackingObjects,
          (result, trackingObject) => {
            extend(result, trackingObject.properties);

            return result;
          },
          {}
        )
      : trackingObjects.properties;
    const trackingEventProps = fromJS({
      [TrackingEvent.KEYS.NAME]: [
        trackingObjectsName,
        trackingAction.name,
      ].join('_'),
      [TrackingEvent.KEYS.PROPERTIES]: extend(
        {},
        trackingObjectsProperties,
        trackingAction.properties,
        additionalProperties
      ),
    });

    return new TrackingEvent(trackingEventProps);
  }
}
